// extracted by mini-css-extract-plugin
export default {"icon":"_fbaf648b","iconBubbleVariant":"_e47bfec2","pinterest":"_4985acb6","facebook":"_1a2e9428","iconWithLabelVariant":"_b309bf78","iconVariant":"_1ace3b3c"};